(function ($) {
  "use strict";

  $(document).ready(function(){

    $('#menu-navigation-horizontal #main-menu-horizontal li.has_dropdown.menu-level-1').hover(function(){

      /* get total padding + border + margin of the popup */
      var extraWidth       = 0
      var wrapWidthPopup   = $(this).find('.dropdown-menu').outerWidth(true); /*include padding + margin + border*/
      var actualWidthPopup = $(this).find('.dropdown-menu').width(); /*no padding, margin, border*/
      extraWidth           = wrapWidthPopup - actualWidthPopup;    
      /* calculate new width of the popup*/
      var new_width_popup = $(this).find('.dropdown-menu .odd2').outerWidth(true);
      var new_outer_width_popup = $(this).find('.dropdown-menu .menu-level-2.nochild').outerWidth(true);
      var n = $(this).find('.dropdown-menu .menu-level-2.has_child' ).length;
      if( n > 1){
        new_outer_width_popup = (new_width_popup  * n) + extraWidth;
        new_width_popup = new_width_popup * n;
      }
      
      /*define top and left of the popup*/
      var wraper = $('#main-menu-horizontal');
      var wWraper = wraper.outerWidth();
      var posWraper = wraper.offset();
      var pos = $(this).offset();
      var xLeft = pos.left - posWraper.left;
      if ((xLeft + new_outer_width_popup) > wWraper) xLeft = wWraper - new_outer_width_popup;
      var max = Math.abs(xLeft) + new_outer_width_popup;
      if (max > wWraper){
        new_outer_width_popup = wWraper;
        xLeft = 0;
      }
      $(this).find('.dropdown-menu').css('left',xLeft);

      /*set new width popup*/
      $(this).find('.dropdown-menu').css('width',new_outer_width_popup);

    });
   }); 

})(jQuery);